/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage} from 'formik';
import { ReactComponent as TensaiIcon } from '../../assets/images/icons/tensai-logo.svg';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import * as yup from 'yup';
import { ThemeProvider } from 'styled-components';
import * as Message from '../../util/messageValidation';
import { Logo, Button } from '../../components';
import { createSession } from '../../stores/actions/access';
import { PageWrapper, Content, Footer, InputField, ContentWrapper, ImageWrapper, IconWrapper, IconBtn, CheckboxWrapper, CheckboxButton, Square, OptionsWrapper, CheckboxText, LgpdDocuments } from './styles';
import light from '../../assets/style/themes/dark';
import loginBackground from '../../assets/images/login-background.png'
import { EyeWatermarkIcon, HiddenEyeWatermarkIcon } from 'src/components/Icons';
import TensaiService from 'src/services/tensai';

const resStringAccess = 'Entrar';
const errNotPermission = 'Não foi possível realizar o login, verifique seus dados de acesso!';
const errUserOrPasswIncorrect = 'E-mail ou senha incorretos';
const errFailOnRequest = 'Houve uma falha na requisição ou no servidor';
const date = new Date()?.getFullYear();

const tensaiService = new TensaiService();

/**
 * Create validation scheme
 */
const schema = yup.object().shape({
  login: yup.string().email(Message.emailValid).required(Message.required).max(70, 'O campo não pode ter mais que 70 caracteres'),
  password: yup.string().required(Message.required).max(70, 'O campo não pode ter mais que 70 caracteres'),
});

/**
 * Login
 */
function Login({ dispatch, running, error, authenticated, needChangePassword }) {
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [checked, setChecked] = useState(true);
  const [userDataError, setUserDataError] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState('');
  const [termsOfUsage, setTermsOfUsage] = useState('');

  const theme = light;

  // initial values
  const initialValues = {
    login: '',
    password: '',
  };

  // handle submit click
  function handleSubmit(values) {
    createSession(values, dispatch);
  }

  // recupera os documentos lgpd
  async function getDocuments() {
    const { data } = await tensaiService.getLgpdDocuments();
    data && data.forEach(({ type, location }) => {
      if(type === 'PRIVACY_POLICY') {
        setPrivacyPolicy(location);
      } else {
        setTermsOfUsage(location);
      }
    });
  }

  // chama a requisição para recuperar os documentos lgpd ao carregar a página
  useEffect(() => {
    getDocuments();
  }, [])

  // error effect
  useEffect(() => {
    if (error) {
      // check error type
      // Foi adicionado a verificação de existência do atributo "status" do objeto errResp
      // no intuito de quando a requisição da API fica com status "pending"
      // e o erro da API não retorna status code em decorrência de timeout
      // ai o navegador estava retornando um erro tentando acessar a propriedade
      // "pending" de um objeto undefined
      const errResp = error.response;
      if (errResp.status && errResp.status === 400) {
        setUserDataError(true);
      } else if (errResp.status && errResp.status > 500) {
        toast.error(errFailOnRequest);
      } else {
        toast.error(errNotPermission);
      }
      // reload page
      history.push('/');
    } else if (authenticated) {
      // redirect to app
      history.push('/app');
      // reload page
      // window.location.reload();
    }
  }, [error, authenticated, needChangePassword, history]);

  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <ContentWrapper>
          <Content>
            <Logo />
            <h1>Bem-vindo de volta!</h1>
            <h3>Faça login na sua conta para continuar</h3>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={schema}
            >
              {({ isValid, errors, handleChange}) => (
                <Form className="form">
                  <InputField isValid={!errors.login}>
                    <Field 
                      name="login" 
                      type="email" 
                      placeholder="Digite seu e-mail" 
                      onChange={(e) => {
                        handleChange(e);
                        setUserDataError(false);
                      }}
                    />
                    <ErrorMessage name="login">
                      {(msg) => <div className="errorMessage">{msg}</div>}
                    </ErrorMessage>
                  </InputField>
                  <InputField isValid={!errors.password}>
                    <IconWrapper>
                      <IconBtn onClick={() => setShowPassword(state => !state)}>
                        {showPassword 
                          ? <EyeWatermarkIcon className='eyeIcon' /> 
                          : <HiddenEyeWatermarkIcon className='eyeIcon' />
                        }
                      </IconBtn>
                      <Field 
                        name="password" 
                        type={showPassword ? 'text' : 'password'} 
                        placeholder="Digite sua senha de acesso"
                        onChange={(e) => {
                          handleChange(e);
                          setUserDataError(false);
                        }}
                      />
                    </IconWrapper>
                    <ErrorMessage name="password">
                      { (msg) => <div className="errorMessage">{msg}</div> }
                    </ErrorMessage>
                    {userDataError && <div className="errorMessage">{errUserOrPasswIncorrect}</div>}
                  </InputField>
                  <OptionsWrapper>
                    <section onClick={() => setChecked(state => !state)}>
                      <CheckboxWrapper>
                        <CheckboxButton>
                          <Square isChecked={checked}  className="checkbox" />
                        </CheckboxButton>
                      </CheckboxWrapper>
                      <CheckboxText>Lembrar de mim</CheckboxText>
                    </section>

                    <Link to="/recuperar-senha">Esqueci minha senha</Link>
                  </OptionsWrapper>
                  <div className="action">
                    <Button 
                      title={resStringAccess} 
                      type="submit" 
                      loading={running}
                      disable={!isValid}
                    />
                  </div>
                </Form>
              )}
            </Formik>

            <Footer>
              <span> Distribuído por &copy; {date} Tensai. Todos os direitos reservados</span>
              <LgpdDocuments>
                <a href={termsOfUsage} target="_blank">Termos de uso</a>
                <span>|</span>
                <a href={privacyPolicy} target="_blank">Política de privacidade</a>
              </LgpdDocuments>
            </Footer> 
          </Content>
        </ContentWrapper>
        <ImageWrapper>
          <img src={loginBackground} alt="Imagem de uma pessoa usando o computador"/>
        </ImageWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}

// [required]
const mapStateToProps = (state) => {
  const accessState = state.access;
  return {
    running: accessState.running,
    error: accessState.error,
    authenticated: accessState.payload ? accessState.payload.authenticated : null,
    needChangePassword: accessState.needChangePassword
  };
};

export default connect(mapStateToProps)(Login);
